import { Truck } from "lucide-react";
import { useLanguage, isRTL } from "@/lib/i18n";
import { FREE_SHIPPING_THRESHOLDS, formatFixedPrice } from "@/lib/fixedPrices";
import { CSSProperties } from "react";

export function ShippingMarquee() {
  const { t, currency, language } = useLanguage();
  const rtl = isRTL(language);

  // Hide marquee for Hebrew
  if (rtl) return null;

  const displayCurrency = currency || 'USD';

  // CAD uses Canada Post calculated rates — no fixed free-shipping threshold
  if (displayCurrency === 'CAD') return null;
  const threshold = FREE_SHIPPING_THRESHOLDS[displayCurrency] || FREE_SHIPPING_THRESHOLDS.USD;
  const amount = formatFixedPrice(threshold, displayCurrency);
  const text = t('product.shippingMarquee', { amount });

  const items = Array.from({ length: 10 }).map((_, i) => (
    <span
      key={i}
      className="inline-flex items-center gap-2 px-8 text-xs md:text-sm font-medium text-primary whitespace-nowrap"
    >
      <Truck className="w-3.5 h-3.5" />
      {text}
    </span>
  ));

  const trackStyle: CSSProperties = {
    display: 'flex',
    width: 'max-content',
    animation: 'scroll-right 40s linear infinite',
  };

  return (
    <div className="w-full overflow-hidden bg-primary/10 py-2.5 mt-1 mb-4 rounded-xl">
      <div style={trackStyle}>
        {items}
        {items.map((_, i) => (
          <span
            key={`dup-${i}`}
            className="inline-flex items-center gap-2 px-8 text-xs md:text-sm font-medium text-primary whitespace-nowrap"
          >
            <Truck className="w-3.5 h-3.5" />
            {text}
          </span>
        ))}
      </div>
    </div>
  );
}
